import SeasonsContent from "../components/Seasons/SeasonsContent";

const Seasons = () => {
    return (
        <SeasonsContent/>
    );
};

export default Seasons;
